export default __webpack_public_path__ + "static/media/1990.fc9af9d6.png";